<template>
<partProgress
  title="部件主页"
/>
</template>

<script>
import partProgress from './partProgress';

export default {
  name: 'homeParts',
  components: {
    partProgress
  }
};
</script>

<style scoped lang="scss">
</style>
